import React, { useState, useEffect } from 'react';
import './UserName.scss';
import UserInfo from './UserInfo';
import UserAction from './UserAction';
import SellTokens from './SellTokens';
import { useUserInfo, useUserInfoUpdate } from "../../../Context/UserContext";
import { Link, useLocation } from "react-router-dom";
const API = process.env.REACT_APP_API_URL
function UserName() {
    const [activeSection, setActiveSection] = useState('actions')
    const [customer, setCustomer] = useState()
    const [history, setHistory] = useState()
    const [tokens, setTokens] = useState()
    const [withdrawals, setWithdrawals] = useState()
    const context = useUserInfo()
    const resetTheClock = useUserInfoUpdate()
    const [note, setNote] = useState();
    const [loadError, setLoadError] = useState();
    const location = useLocation();
    const userId = new URLSearchParams(location.search).get('u');

    useEffect(() => {
        const selectedCustomer = context.userInfo?.users?.find(
            user => user.user_id === userId
        );
        setCustomer(selectedCustomer);
    }, [context.userInfo, userId]);

    useEffect(() => {
        if (!context.accessToken || !userId) return;

        let cancelled = false;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${context.accessToken}`
        };
        const getJson = async (path) => {
            const response = await fetch(`${API}${path}`, {
                method: 'GET',
                mode: 'cors',
                headers
            });
            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }
            return response.json();
        };

        setLoadError(undefined);
        Promise.all([
            getJson(`/history/${userId}`),
            getJson(`/getTokensByOwner/${userId}`),
            getJson(`/getNotes/${userId}`),
            getJson(`/getMyWithdrawals/${userId}`)
        ])
            .then(([historyResult, tokenResult, noteResult, withdrawalResult]) => {
                if (cancelled) return;
                setHistory(historyResult);
                setTokens(tokenResult);
                setNote(noteResult);
                setWithdrawals(
                    withdrawalResult.filter(withdrawal => withdrawal.sent === "pending")
                );
            })
            .catch(() => {
                if (!cancelled) {
                    setLoadError("This customer could not be reloaded. Please try again.");
                }
            });

        return () => {
            cancelled = true;
        };
    }, [context.accessToken, userId]);

    const updateActiveSection = (sectionName) => {
        setActiveSection(sectionName);
    }

    const active = (tabName) => {
        if (tabName === activeSection) return 'active'
        else return ''
    }

    return (
        context &&
        <div className="userNamePage">
            <div className="pageTitle">
                <p>EDIT USER INFO FOR PLATFORM</p>
                {customer != undefined && <div className="pageHeader">{customer.first_name + ' ' + customer.last_name} ({customer.membership})</div>}
            </div>
            {!userId && (
                <div className="pageContent">
                    <p>No customer was selected. <Link to="/Platform">Choose a customer</Link>.</p>
                </div>
            )}
            {userId && loadError && (
                <div className="pageContent">
                    <p>{loadError}</p>
                </div>
            )}
            <div className="mobileButton">
                <div className="buttonContent">
                    <button className={`${active('actions')}`} onClick={() => updateActiveSection('actions')}>Actions</button>
                    <button className={`${active('info')}`} onClick={() => updateActiveSection('info')}>Info</button>
                </div>
            </div>
            {customer && <div className="pageContent">
                <UserAction
                    customer={customer}
                    accessToken={context.accessToken}
                    aum={context.userInfo.aum}
                    withdrawals={withdrawals}
                    resetTheClock={resetTheClock} />
                <UserInfo
                    accessToken={context.accessToken}
                    customer={customer}
                    history={history}
                    assets={tokens}
                    resetTheClock={resetTheClock}
                    note={note} />
            </div>}
            {customer && <div className="pageContentMobile">
                {activeSection === 'actions' ? (
                    <UserAction customer={customer}
                        accessToken={context.accessToken}
                        aum={context.userInfo.aum}
                        withdrawals={withdrawals}
                        resetTheClock={resetTheClock} />
                ) : (
                    <UserInfo
                        accessToken={context.accessToken}
                        customer={customer}
                        history={history}
                        assets={tokens}
                        resetTheClock={resetTheClock}
                        note={note} />
                )}
            </div>}
        </div>
    )
}

export default UserName
